import { Text } from "@mantine/core";
import { DataGridPage, EntityClientAction } from "@mcurros2/microm";
import { Regiones } from "./Regiones";
import { RegionesTiendas } from "./RegionesTiendas/RegionesTiendas";

export const ACTGestionarTiendas: EntityClientAction = {
    name: 'ACTGestionarTiendas',
    label: 'Gestionar Tiendas',
    title: <Text fw={700}>Gestionar Tiendas</Text>,
    refreshOnClose: true,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        // cast entity
        const parent = entity as Regiones;
        const tiendas = new RegionesTiendas(entity.API.client);
        tiendas.parentKeys = { ...parent.parentKeys, ...{ vc_nombre_region: selectedKeys![0].vc_nombre_region } };
        tiendas.def.columns.c_region_id.value = selectedKeys![0].c_region_id as unknown as string || '';

        if (modal) {
            await modal.open({
                modalProps: {
                    title: <Text fw="700">Gestionar Tiendas</Text>,
                    size: 'xl',
                },
                focusOnClosed: element,
                onClosed: async () => {
                    if (onClose) await onClose();
                },
                content:
                    <DataGridPage
                        key="region-tiendas"
                        client={entity.API.client}
                        entityConstructor={() => tiendas}
                        formMode="edit"
                        viewName="regt_brwTiendasPorRegion"
                        parentKeys={tiendas.parentKeys}
                        refreshOnInit
                        enableAdd={false}
                        enableDelete={false}
                        enableEdit={false}
                        enableView={false}
                        showActions={true}
                        title={`Gestionar ${selectedKeys![0].vc_nombre_region}`}
                        selectionMode="multi" />
            });
        }
        else {
            console.log('modal context not found');
        }

        return Promise.resolve(false);

    }

}

